import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import mgs_alert from '../../sounds/MGS_alert.mp3'

import { shufflaa } from '../../utils/randomize'

import { data_base, data_A, data_B, data_C } from './data/data_03_stairs_up.js'
import base from './images/portaat_up/base.png'
import right_foot_up from './images/portaat_up/right_foot_up.gif'
import right_foot_returns_down from './images/portaat_up/right_foot_returns_down.gif'
import left_foot_returns_down from './images/portaat_up/left_foot_returns_down.gif'
import left_foot_up from './images/portaat_up/left_foot_up.gif'
import horjahdus from './images/portaat_up/horjahdus_taakse.png'
import kaaduttu_taakse from './images/portaat_up/kaaduttu_taakse.png'
import left_and_sticks_following_right from './images/portaat_up/left_and_sticks_following_right.gif'
import both_sticks_up from './images/portaat_up/both_sticks_up.gif'
import both_sticks_return_down from './images/portaat_up/both_sticks_return_down.gif'
import right_foot_follows_sticks from './images/portaat_up/right_foot_follows_sticks.gif'
import jump from './images/portaat_up/jump_up_and_fall.gif'


import Noppa from '../../additionalComponents/Noppa.js';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const Stairs_up = ({ scoreHandler, visibilityHandler, soundsOn }) => {


    let lista = null

    //Statemjat
    const [teksti, setTeksti] = useState('')
    const [optiot1, setOptiot1] = useState([])
    const [optiot2, setOptiot2] = useState([])

    const [image, setImage] = useState(base)

    const [time1, setTime1] = useState(0)
    const [tarvittavaNopanArvo, setTarvittavaNopanArvo] = useState(null)
    const [noppaMsg, setNoppaMsg] = useState('')
    const [continuable, setContinuable] = useState(false)
    const [nextScene, setNextScene] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [closeActive, setCloseActive] = useState(false);
    const [nopataan, setNopataan] = useState(false);

    const [horjantanut, setHorjantanut] = useState(false);



    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [playMgsAlert] = useSound(mgs_alert);


    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        setOptiot1(data_base.optiot)
        setTeksti(data_base.kysymysteksti)
        setTime1(Date.now())
    }, [])

    // optiot2:een shufflattu järjestys
    useEffect(() => {//
        if (optiot1.length != 0) {
            setOptiot2(shufflaa(optiot1))
        }
    }, [optiot1])



    const handleClose = () => {

        setShowModal(false);
    }
    const handleShowModal = () => {
        setShowModal(true);
        setCloseActive(false)
    }

    const handlaaArvontatulos = (e) => {
        if (e >= tarvittavaNopanArvo) {
            // Lisätään trial--> ei voi saada enää pistettä (tai 50% vähennys jos max 1 yritys takana) TAI jos horjahtanut edes kerran, vähennys)
            //gif, jossa palataan alkuun (oik. jalka palaa taakse)
            setOptiot1(data_base.optiot)
            setImage(right_foot_returns_down)
            setTeksti("Huh, se oli lähellä, yritetään vielä uudelleen alusta. "
                + data_base.kysymysteksti)


        }
        else {
            setTeksti("Pena kaatui, Game over")
            setImage(kaaduttu_taakse)
            setOptiot2([])
            // Lisää lopetustoimenpiteet



        }
        setNopataan(false)
        setCloseActive(true)//aktivoi modaalin sulkunapin
        setContinuable(true)

    }


    const klikattuKuvaa = (optio) => {

        //tässä scenessä MGS_alertti -> toistaiseksi jätän muut äänet pois
        // if (soundsOn) {

        //     if (Number(optio.pisteet) > 0) {
        //         playCorrectAnswer()
        //     }
        //     else {
        //         playWrongAnswer()
        //     }

        // }



        switch (optio.valinta) {
            case "A":
                setImage(right_foot_up)
                setOptiot1(data_A.optiot)
                setTeksti(data_A.kysymysteksti)
                break;
            case "AA":
                setImage(left_and_sticks_following_right)//NB uusi gif, tää heikko 
                setTeksti("Juurikin näin ylöspäin - seuraavaksi katsotaan miten alaspäin meno tapahtuu.")
                visibilityHandler("portaat ylös ok")


                // enabloi/ näytä jatka-nappi 
                break;
            case "AB"://palauta oikea jalka takaisin
                setImage(right_foot_returns_down)//tee giffi right_foot_up päinv järjestyksessä
                setOptiot1(data_base.optiot)
                setTeksti(data_base.kysymysteksti)
                break;
            case "AC"://vasen jalka, sitten sauvat-->kaatuu nopalla
                // joku samanlainen ääni kuin vaikka MGS kun Snake paljastuu-->noppa
                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 3, hän ei kaadu!")
                setHorjantanut(true)
                setTarvittavaNopanArvo(3)
                setImage(horjahdus)
                setNopataan(true)


                break;

            case "AD"://sauvat ensin, sitten ponnista oikealla-->kaatuu nopalla

                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 2, hän ei kaadu!")
                setHorjantanut(true)
                setTarvittavaNopanArvo(2)
                setImage(horjahdus)
                setNopataan(true)

                break;




            case "B":
                setImage(left_foot_up)
                setOptiot1(data_B.optiot)
                setTeksti(data_B.kysymysteksti)
                break;
            case "BA":
                // palauttaa vasemman alas --> base
                setImage(left_foot_returns_down)
                setOptiot1(data_base.optiot)
                setTeksti(data_base.kysymysteksti)
                break;
            case "BB":
                // ponnistus vasemmalla--> horjahdus
                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 5, hän ei kaadu!")
                setHorjantanut(true)
                setTarvittavaNopanArvo(5)
                setImage(horjahdus)
                setNopataan(true)
                break;


            case "C":
                //molemmat sauvat yläportaalle
                setImage(both_sticks_up)
                setOptiot1(data_C.optiot)
                setTeksti(data_C.kysymysteksti)
                break;
            case "CA":

                setImage(both_sticks_return_down)
                setOptiot1(data_base.optiot)
                setTeksti("Palautit sauvat takaisin alas - hyvä. " + data_base.kysymysteksti)
                break;
            case "CB":

                // sauvat yläportaalla--> yritetään astua oikealla--> horjahdus
                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 2, hän ei kaadu!")
                setHorjantanut(true)
                setTarvittavaNopanArvo(2)
                setImage(horjahdus)
                setNopataan(true)
                break;


            case "D":
                // hypätään tasajalkaa -->horjahdus
                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 6, hän ei kaadu!")
                setHorjantanut(true)
                setTarvittavaNopanArvo(6)
                // setImage(horjahdus)
                setImage(jump)
                setNopataan(true)
                break;


        }


        // scoreHandler(optio, data.scene, data.maxp) // ei vielä tässä kohti -->vasta kun ylös päin koko askel

        // visibilityHandler(optio.valinta)
    }

    if (optiot2.length != 0) {
        lista = optiot2.map(optio =>
            <li key={optio.id}>

                <span className='clickable'

                    onClick={() => klikattuKuvaa(optio)}

                >
                    {optio.teksti}
                </span>
            </li>
        );
    }
    return (

        <div className='sceneContainer'>

            <div id='image'>
                <img className='sameSizeImg' src={image} alt='kuva' />
            </div>

            <div id='question'>
                <h5>{(teksti != null && teksti != "") ? teksti : null}</h5>
            </div>

            <div id='actions'>


                {!nopataan ? <ul>
                    {lista}
                </ul> : null}

                {nopataan ? <>
                    <Button variant="primary" onClick={handleShowModal}>
                        Heitä noppaa
                    </Button>
                </> : null}

                <Modal
                    show={showModal}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >


                    {/* <Modal.Header closeButton>
                                <Modal.Title>Modal title</Modal.Title>
                            </Modal.Header> */}
                    <Modal.Body>
                        <Noppa
                            soundsOn={soundsOn}
                            handlaa={handlaaArvontatulos}
                            tarvittavaNopanArvo={tarvittavaNopanArvo}
                        // sulku={handleClose}
                        />


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}
                            disabled={!closeActive}
                        >
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )

}

export default Stairs_up